// LighthouseAnimation.jsx
import React from 'react';
import './LighthouseAnimation.css'; // We'll create this file next

export default function LighthouseAnimation() {
  return (
	<div className="lighthouse-animation-wrapper">
    <div className="lighthouse-animation-container">
      <div className="scene">
        <div className="background">
          <div className="stars">
            {/* All the star divs */}
            {[...Array(60)].map((_, i) => (
              <div key={i} className="star"></div>
            ))}
          </div>
          <div className="moon"></div>
          <div className="mountains">
            <div className="mountain"></div>
            <div className="mountain"></div>
            <div className="mountain"></div>
            <div className="mountain"></div>
          </div>
          <div className="sea">
            {[...Array(30)].map((_, i) => (
              <div key={i} className="wave"></div>
            ))}
            <div className="boat">
              <div className="sail"></div>
              <div className="sail"></div>
              <div className="base"></div>
            </div>
          </div>
        </div>
        <div className="lighthouse-group">
          <div className="land"></div>
          <div className="lighthouse-holder">
            <div className="shadow"></div>
            <div className="lighthouse"></div>
            <div className="top">
              <div className="light-container">
                <div className="light"></div>
              </div>
              <div className="rail"></div>
              <div className="middle"></div>
              <div className="roof">
                <div className="roof-light"></div>
              </div>
              <div className="glow"></div>
            </div>
            <div className="windows">
              <div className="window"></div>
              <div className="window"></div>
              <div className="window"></div>
              <div className="window"></div>
            </div>
            <div className="door">
              <div className="stairs"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
  );
}